<template>
  <v-container fluid>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>

        <div v-else>
          <v-row>
            <v-col cols="6" md="3" class="py-0">
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.start_date"
                    label="מתאריך"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.start_date"
                  @input="(startDateMenu = false), get_data()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" md="3" class="py-0">
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.end_date"
                    label=" עד תאריך "
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.end_date"
                  @input="(endDateMenu = false), get_data()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-simple-table class="mt-5">
            <template v-slot:default>
              <tbody class="text-center font-weight-bold">
                <tr v-for="(item, index) in items" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.ready_time }} דקות</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "products_page",
  data() {
    return {
      data_loaded: false,
      filters: {
        start_date: "",
        end_date: "",
      },
      startDateMenu: false,
      endDateMenu: false,
      items: [],
    };
  },
  methods: {
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `ordersLogsReport?start_date=${this.filters.start_date}&end_date=${this.filters.end_date}`,
            method: "get",
          },
        })
        .then((res) => {
          this.items = res.data.data;
          this.data_loaded = true;
        });
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>
